module.exports = __webpack_public_path__ + "img/mon_rotated.caec4f99.png";